import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Übersetzungsressourcen
const resources = {
  de: {
    translation: {
      // Login Page
      appTitle: "Strength Pilot",
      membersOnly: "Melde dich mit deinem Account an.",
      writeEmail: "Schreibe eine",
      forAccess: "für Zugang.",
      email: "E-Mail",
      password: "Passwort",
      login: "Anmelden",
      forgotPassword: "Passwort vergessen?",
      loginFailed: "❌ Login fehlgeschlagen. Bitte überprüfe deine Eingaben.",
      enterEmailFirst: "Bitte geben Sie zuerst Ihre E-Mail-Adresse ein",
      passwordResetSent: "✅ Falls ein Konto existiert, haben wir dir einen Reset-Link geschickt.",
      error: "❌ Fehler: ",
      version: "Version",
      copyright: "© {{year}} Strength Pilot",
    },
  },
  en: {
    translation: {
      // Login Page
      appTitle: "Strength Pilot",
      membersOnly: "Sign in with your account.",
      writeEmail: "Write an",
      forAccess: "for access.",
      email: "Email",
      password: "Password",
      login: "Sign In",
      forgotPassword: "Forgot password?",
      loginFailed: "❌ Login failed. Please check your credentials.",
      enterEmailFirst: "Please enter your email address first",
      passwordResetSent: "✅ If an account exists for this email, we've sent you a reset link.",
      error: "❌ Error: ",
      version: "Version",
      copyright: "© {{year}} Strength Pilot",
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en", // default language
    fallbackLng: "en",

    interpolation: {
      escapeValue: false, // react already does escaping
    },
  });

export default i18n;
